import React from "react";
import { styles, ApplyNow, Description } from "./style.ts";
import Utils from "../../../lib/utils";

  const apply = (handleApply, history) => {
    if (Utils.isSignedIn()) {
      handleApply();
    } else {
      history.push(`/login`);
    }
  };

const JobDescription = ({ applied, user, job, handleApply, history }) => (
  <Description>
    <h1 style={styles.title}>Job Description</h1>
    <div
      style={styles.description}
      dangerouslySetInnerHTML={{
        __html: Utils.stripHtml(job.description),
      }}
    />
    {!applied && !Utils.isEmployer(user) && !Utils.hasApplied(user, job) && (
      <ApplyNow className="btn btn-primary btn_apply" onClick={() => apply(handleApply, history)}>
        Apply now
      </ApplyNow>
    )}
  </Description>
);

export default JobDescription;
